import type { ReactNode } from 'react'

import { useCapability } from '../hooks'

interface CapabilityGateProps {
  /** Capability id from the shared catalogue. */
  capability: string
  children: ReactNode
}

/**
 * Renders children only when the signed-in user's role holds the capability.
 *
 * Nothing is offered until the answer says so. A capability an organization
 * does not hold must not appear to anyone in it, and rendering first means
 * offering it — briefly, but really — before withdrawing it.
 */
export function CapabilityGate({ capability, children }: CapabilityGateProps) {
  const allowed = useCapability(capability)

  if (allowed !== true) return null
  return <>{children}</>
}
